// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"VoiceControlsPageMobile_headerContainer__2jLAQ"};